import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Stack } from '../../Stack';
import { Affix } from '../Affix/Affix';
import { ErrorIcon } from '../ErrorIcon';

const MaxCharacterCountElement = styled(Affix)<{ inline?: boolean; error?: boolean }>`
    ${({ inline }) =>
        !inline &&
        css`
            margin-top: ${getSpacingToken('50')}px;
            width: fit-content;
        `};
    ${({ error }) =>
        error &&
        css`
            color: ${getToken('textAlertDanger')};
        `};
    ${({ $disabled }) =>
        $disabled &&
        css`
            color: ${getToken('textDisabled')};
        `};
`;

export interface MaxCharacterCountProps {
    inline?: boolean;
    inputValueLength: number;
    maxCharacterCount: number;
    disabled?: boolean;
}

export const MaxCharacterCount = ({
    inline,
    inputValueLength,
    maxCharacterCount,
    disabled,
}: MaxCharacterCountProps) => {
    const error = inputValueLength > maxCharacterCount;

    return (
        <MaxCharacterCountElement inline={inline} error={error} data-test-character-count $disabled={disabled}>
            <Stack spacing="50" alignment="end">
                {error ? <ErrorIcon /> : null}
                <span>{`${inputValueLength}/${maxCharacterCount}`}</span>
            </Stack>
        </MaxCharacterCountElement>
    );
};
